/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const deleteResident = /* GraphQL */ `mutation DeleteResident(
  $input: DeleteResidentInput!
  $condition: ModelResidentConditionInput
) {
  deleteResident(input: $input, condition: $condition) {
    id
    phone
    email
    personalEmail
    groupRead
    groupWrite
    internalId
    externalId
    activeAdmission
    activeCommunityNumber
    activeCommunity
    firstAdmission
    mrn
    address {
      addressLine1
      addressLine2
      city
      state
      zipcode
      __typename
    }
    birthDate
    deathDate
    gender
    firstName
    middleName
    lastName
    activeAdmissionId
    activeLevelOfCare
    onLeave
    leaveStartDate
    activeAdmissions {
      admissionId
      community
      levelOfCare
      dateActive
      dateInactive
      bed
      room
      floor
      building
      onLeave
      leaveStartDate
      __typename
    }
    previousAdmissions {
      admissionId
      community
      levelOfCare
      dateActive
      dateInactive
      bed
      room
      floor
      building
      onLeave
      leaveStartDate
      __typename
    }
    preferredName
    covidVaccineRound
    community
    bed
    room
    floor
    building
    lOfCare
    currentIntakeId
    locations
    status
    activationStatus
    activationStartDate
    activationEndDate
    pingAccessStartDate
    lastLoginDateTime
    personType
    salesforceID
    touchtownUpdatedAt
    active
    locked
    locationID
    type
    contactInfo {
      street1
      street2
      city
      state
      zip
      phones {
        value
        type
        preferred
        hidden
        __typename
      }
      __typename
    }
    cell
    preferences {
      fontSize
      __typename
    }
    profile {
      includeInDirectory
      externalCalendarEnabled
      aboutMe
      birthPlace
      favoriteThings
      interests
      profession
      __typename
    }
    customData {
      mrn
      mealPlan {
        type
        title
        description
        period
        balance
        total
        __typename
      }
      __typename
    }
    preferredFirstName
    note
    touchtownUpdateStatus
    openSearchStatus
    salesforceProfileID
    touchTownUpdatedBy
    updatedBy
    myUnityPhones {
      value
      type
      preferred
      hidden
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteResidentMutationVariables,
  APITypes.DeleteResidentMutation
>;
export const createResident = /* GraphQL */ `mutation CreateResident(
  $input: CreateResidentInput!
  $condition: ModelResidentConditionInput
) {
  createResident(input: $input, condition: $condition) {
    id
    phone
    email
    personalEmail
    groupRead
    groupWrite
    internalId
    externalId
    activeAdmission
    activeCommunityNumber
    activeCommunity
    firstAdmission
    mrn
    address {
      addressLine1
      addressLine2
      city
      state
      zipcode
      __typename
    }
    birthDate
    deathDate
    gender
    firstName
    middleName
    lastName
    activeAdmissionId
    activeLevelOfCare
    onLeave
    leaveStartDate
    activeAdmissions {
      admissionId
      community
      levelOfCare
      dateActive
      dateInactive
      bed
      room
      floor
      building
      onLeave
      leaveStartDate
      __typename
    }
    previousAdmissions {
      admissionId
      community
      levelOfCare
      dateActive
      dateInactive
      bed
      room
      floor
      building
      onLeave
      leaveStartDate
      __typename
    }
    preferredName
    covidVaccineRound
    community
    bed
    room
    floor
    building
    lOfCare
    currentIntakeId
    locations
    status
    activationStatus
    activationStartDate
    activationEndDate
    pingAccessStartDate
    lastLoginDateTime
    personType
    salesforceID
    touchtownUpdatedAt
    active
    locked
    locationID
    type
    contactInfo {
      street1
      street2
      city
      state
      zip
      phones {
        value
        type
        preferred
        hidden
        __typename
      }
      __typename
    }
    cell
    preferences {
      fontSize
      __typename
    }
    profile {
      includeInDirectory
      externalCalendarEnabled
      aboutMe
      birthPlace
      favoriteThings
      interests
      profession
      __typename
    }
    customData {
      mrn
      mealPlan {
        type
        title
        description
        period
        balance
        total
        __typename
      }
      __typename
    }
    preferredFirstName
    note
    touchtownUpdateStatus
    openSearchStatus
    salesforceProfileID
    touchTownUpdatedBy
    updatedBy
    myUnityPhones {
      value
      type
      preferred
      hidden
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateResidentMutationVariables,
  APITypes.CreateResidentMutation
>;
export const updateResident = /* GraphQL */ `mutation UpdateResident(
  $input: UpdateResidentInput!
  $condition: ModelResidentConditionInput
) {
  updateResident(input: $input, condition: $condition) {
    id
    phone
    email
    personalEmail
    groupRead
    groupWrite
    internalId
    externalId
    activeAdmission
    activeCommunityNumber
    activeCommunity
    firstAdmission
    mrn
    address {
      addressLine1
      addressLine2
      city
      state
      zipcode
      __typename
    }
    birthDate
    deathDate
    gender
    firstName
    middleName
    lastName
    activeAdmissionId
    activeLevelOfCare
    onLeave
    leaveStartDate
    activeAdmissions {
      admissionId
      community
      levelOfCare
      dateActive
      dateInactive
      bed
      room
      floor
      building
      onLeave
      leaveStartDate
      __typename
    }
    previousAdmissions {
      admissionId
      community
      levelOfCare
      dateActive
      dateInactive
      bed
      room
      floor
      building
      onLeave
      leaveStartDate
      __typename
    }
    preferredName
    covidVaccineRound
    community
    bed
    room
    floor
    building
    lOfCare
    currentIntakeId
    locations
    status
    activationStatus
    activationStartDate
    activationEndDate
    pingAccessStartDate
    lastLoginDateTime
    personType
    salesforceID
    touchtownUpdatedAt
    active
    locked
    locationID
    type
    contactInfo {
      street1
      street2
      city
      state
      zip
      phones {
        value
        type
        preferred
        hidden
        __typename
      }
      __typename
    }
    cell
    preferences {
      fontSize
      __typename
    }
    profile {
      includeInDirectory
      externalCalendarEnabled
      aboutMe
      birthPlace
      favoriteThings
      interests
      profession
      __typename
    }
    customData {
      mrn
      mealPlan {
        type
        title
        description
        period
        balance
        total
        __typename
      }
      __typename
    }
    preferredFirstName
    note
    touchtownUpdateStatus
    openSearchStatus
    salesforceProfileID
    touchTownUpdatedBy
    updatedBy
    myUnityPhones {
      value
      type
      preferred
      hidden
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateResidentMutationVariables,
  APITypes.UpdateResidentMutation
>;
export const createIDMSLogRecordV1 = /* GraphQL */ `mutation CreateIDMSLogRecordV1(
  $input: CreateIDMSLogRecordV1Input!
  $condition: ModelIDMSLogRecordV1ConditionInput
) {
  createIDMSLogRecordV1(input: $input, condition: $condition) {
    id
    level
    action
    objectId
    oldMessage
    message
    updatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateIDMSLogRecordV1MutationVariables,
  APITypes.CreateIDMSLogRecordV1Mutation
>;
export const updateIDMSLogRecordV1 = /* GraphQL */ `mutation UpdateIDMSLogRecordV1(
  $input: UpdateIDMSLogRecordV1Input!
  $condition: ModelIDMSLogRecordV1ConditionInput
) {
  updateIDMSLogRecordV1(input: $input, condition: $condition) {
    id
    level
    action
    objectId
    oldMessage
    message
    updatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateIDMSLogRecordV1MutationVariables,
  APITypes.UpdateIDMSLogRecordV1Mutation
>;
export const deleteIDMSLogRecordV1 = /* GraphQL */ `mutation DeleteIDMSLogRecordV1(
  $input: DeleteIDMSLogRecordV1Input!
  $condition: ModelIDMSLogRecordV1ConditionInput
) {
  deleteIDMSLogRecordV1(input: $input, condition: $condition) {
    id
    level
    action
    objectId
    oldMessage
    message
    updatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteIDMSLogRecordV1MutationVariables,
  APITypes.DeleteIDMSLogRecordV1Mutation
>;
